import {
  Typography,
  Box,
  List,
  ListItem,
  Avatar,
  Divider,
  Grid,
  Button,
} from '@mui/material';
import { East as EastIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import dummyImage from '../../assets/images/dummyprofile.jpg';
import { OutlinedButton } from '../index';

const style = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  pb: 3,
  pt: 4,
  px: 5,
};

const name = {
  fontWeight: '700',
  fontSize: '1.8rem',
  ml: 2,
};

const infoTitle = {
  mr: '1rem',
  fontWeight: '500',
};

const badge = {
  bgcolor: '#84d8c5',
  borderRadius: '4px',
  px: 1,
  py: 0.2,
  fontWeight: 500,
  textTransform: 'uppercase',
  ml: 2,
};

const card = {
  bgcolor: '#3A4152',
  // border: "1px solid rgba(255, 255, 255, 0.3)",
  borderRadius: '5px',
  py: 1.6,
  width: '100%',
  color: '#fff',
  fontSize: '1rem',
  fontWeight: 'Light',
  // '&:hover': {
  //   bgcolor: "#FFF",
  //   borderColor: "rgb(173, 59, 55)",
  // },
};

const iconStyle = {
  fill: '#84d8c5 !important',
};

export const UserInfo = (props) => {
  let navigate = useNavigate();
  const fullname = props.fullName;

  const routeChange = () => {
    let path = '/profile';
    navigate(path);
  };
  return (
    <Box sx={style}>
      <Grid container sx={{ mb: 3, justifyContent: 'center' }}>
        <Grid item xs={4}>
          <Avatar
            alt={fullname}
            src={dummyImage}
            sx={{ width: 150, height: 150, mx: 'auto' }}
          />
        </Grid>
        <Grid item xs={8}>
          <Typography sx={name} variant="h4" component="div">
            {fullname.toUpperCase()}
          </Typography>
          {/* <Typography variant="caption" sx={badge}>
            Frontend Developer
          </Typography> */}
          <List sx={{ mt: 1 }}>
            <ListItem sx={{ py: 0.2 }}>
              <Typography sx={infoTitle}>Email:</Typography>
              <Typography>{props.email}</Typography>
            </ListItem>
            <ListItem sx={{ py: 0.2 }}>
              <Typography sx={infoTitle}>Phone Number:</Typography>
              <Typography>{props.phone}</Typography>
            </ListItem>
            <ListItem sx={{ py: 0.2 }}>
              <Typography sx={infoTitle}>Department:</Typography>
              <Typography>{props.deptname}</Typography>
            </ListItem>
          </List>
        </Grid>
      </Grid>
      <Divider />
      <Typography
        sx={{ mt: 1 }}
        variant="h6"
        align="center"
        textTransform={'uppercase'}
      >
        LINKS
      </Typography>
      <Grid
        container
        spacing={1}
        sx={{ mt: 1, mb: 2, justifyContent: 'center' }}
      >
        <Grid item xs={6}>
          <Button
            sx={card}
            target="_blank"
            href="https://forms.office.com/r/uyEX0sDfiD"
          >
            OT Application
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            sx={card}
            target="_blank"
            href="https://forms.office.com/r/CVLLjC1zff"
          >
            Leave Application
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            sx={card}
            target="_blank"
            href="https://ibridgeph.sharepoint.com/:x:/s/iBPCommon/EWMsaEe9bXpIr8COpbqMnBABvmMlvdXulCaL3vWLWLOekA?e=eIuRfv"
          >
            Hybrid Setup Calendar
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            sx={card}
            target="_blank"
            href="https://redmine.ibpappps.com/"
          >
            iBP Redmine
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            sx={card}
            target="_blank"
            href="https://gitlabce.ibpappps.com/"
          >
            iBP Gitlab
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            sx={card}
            target="_blank"
            href="https://ibridgeph-my.sharepoint.com/"
          >
            OneDrive
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            sx={card}
            target="_blank"
            href="https://forms.office.com/Pages/ResponsePage.aspx?id=OH7lj3G5ikiH0QcVp5rvgwnMCNpDGVtOiNTK2hFTVtxURFNQV08zVEdPQlRBOENZNVM0VExLUjFGVi4u"
          >
            Asset Request/Release Form
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            sx={card}
            target="_blank"
            href="https://forms.office.com/r/7exTdYzjnE"
          >
            Trainings/Seminar Attended
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            sx={card}
            target="_blank"
            href="https://forms.office.com/r/UEDkb1J42X"
          >
            Certifications/Qualifications
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            sx={card}
            target="_blank"
            href="https://ibridgeph.sharepoint.com/:f:/r/sites/iBPCommon/Shared%20Documents/iBP_Memo_and_Policies?csf=1&web=1&e=GGPexM"
          >
            Memos and Policies
          </Button>
        </Grid>
        {/* <Grid item  xs={6}>
          <Typography sx={card} align="center">EPS Modernization</Typography>
        </Grid> */}
      </Grid>

      {/* [EPSv5_Dashboard-EditProfileButton] Commented out for reimplementation*/}
      {/* <OutlinedButton
        // sx={btnStyle}
        style={{mt: "auto"}}
        variant="outlined"
        endIcon={<EastIcon sx={iconStyle} />}
        onClick={routeChange}
        btnTitle="Edit Profile"
      /> */}
    </Box>
  );
};
